import React from 'react';
import cn from 'classnames';

import styles from './styles.module.scss';

const Select = ({ error, className, innerRef, children, ...props }) => {
  return (
    <div
      className={cn({
        [styles.wrapper]: true,
        [className]: className,
        [styles.error]: error,
      })}
    >
      <select
        className={cn('text-s', styles.input)} // Reusing styles.input usually works for select too
        ref={innerRef}
        {...props}
      >
        {children}
      </select>
      {error && <span className={cn('text-xs', styles.errorMsg)}>{error}</span>}
    </div>
  );
};

export default Select;
